export default __webpack_public_path__ + "static/tooltip-info-dont-light-1f94877976bca4f3e776b2822270ce0cbba2ae4c486ee83627ae7479960b24c7.png";